



























































































































































import VueBase from '@/VueBase'
import { Component } from 'vue-property-decorator'
@Component({ name: 'SysInfo' })
export default class SysInfo extends VueBase {
  public activeName = 'global'
  public form = {
    cpu_limit: '',
    vul_verifiy: 0,
  }
  onSubmit() {
    console.log('确定')
  }

  get userInfo() {
    return this.$store.getters.userInfo
  }
  async getInfo() {
    const keys = []
    for (let key in this.form) {
      keys.push(key)
    }
    const res = await this.services.setting.profileGet({
      keys,
    })
    if (res.status === 201) {
      res.data.forEach((item: any) => {
        this.form[item.key] = item.value
      })
    } else {
      this.$message.error(res.msg)
    }
  }

  async profileModified() {
    const data = []
    for (let key in this.form) {
      data.push({
        value: String(this.form[key]),
        key,
      })
    }
    const res = await this.services.setting.profileModified(data)
    if (res.status === 201) {
      this.$message.success(res.msg)
    } else {
      this.$message.error(res.msg)
    }
  }

  private jsons: any = []
  private async get_threshold() {
    const res = await this.services.setting.get_threshold()
    if (res.status === 201) {
      this.jsons = res.data.result
    }
  }

  private async edit(row: any) {
    this.$router.push({ name: 'agentConfig', query: { id: row.id } })
  }

  private async del(row: any) {
    this.$confirm(this.$t('views.agentConfig.confirmDel') as string, '', {
      confirmButtonText: this.$t('views.agentConfig.confirm') as string,
      cancelButtonText: this.$t('views.agentConfig.cancel') as string,
      type: 'warning',
    }).then(async () => {
      const res = await this.services.setting.del_threshold({ id: row.id })
      if (res.status === 201) {
        this.$message.success(res.msg)
        this.get_threshold()
        return
      }
      this.$message.error(res.msg)
    })
  }
  add() {
    this.$router.push({ name: 'agentConfig' })
  }
  async activated() {
    this.get_threshold()
    this.getInfo()
  }
}
